export default __webpack_public_path__ + "static/media/logo_mb.7b272354.svg";